class KiwiService {
	static createTarget (targetName) {
		const {kiwi} = window;
		if (kiwi) {
			kiwi.createTarget(targetName);
		}
	}

	static playVideoFullHD (targetName, url, mime, onFinishCallback) {
		const {kiwi} = window;
		if (!kiwi) {
			return -1;
		}
		kiwi.showTarget(targetName, 0, 0, 1920, 1080);
		return kiwi.play(url, mime,
			{
				target: targetName,
				popup: true,
				parameters: {
				},
				onFinished: onFinishCallback
			}
		);
	}

	static playVideo (targetName, url, mime, onFinishCallback) {
		const {kiwi} = window;
		if (!kiwi) {
			return -1;
		}
		kiwi.showTarget(targetName);
		return kiwi.play(url, mime,
			{
				target: targetName,
				popup: true,
				parameters: {
				},
				onFinished: onFinishCallback
			}
		);
	}
	static hideVideo (targetName) {
		const {kiwi} = window;
		if (kiwi) {
			kiwi.hideTarget(targetName);
		}
	}
}

export default KiwiService;



// WEBPACK FOOTER //
// ./src/kiwi/kiwi-service.js